import {PlatformToastMessageType } from './platformToastMessageType';

export class PlatformToastMessage {

    constructor(public messageType: PlatformToastMessageType,
                public message: string,
                public title?: any, 
                public onActivateTick: boolean = false) {}
}
